import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=422e557e&"
import script from "./Carousel.vue?vue&type=script&lang=js&"
export * from "./Carousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plenty24/3672/203/Bigtex5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('422e557e')) {
      api.createRecord('422e557e', component.options)
    } else {
      api.reload('422e557e', component.options)
    }
    module.hot.accept("./Carousel.vue?vue&type=template&id=422e557e&", function () {
      api.rerender('422e557e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/bigtex/Carousel.vue"
export default component.exports